module.exports = __webpack_public_path__ + "img/1x3_ad.26924554.png";